<template>
  <div class="columns is-multiline recipe-list">
    <RecipeComponent
      v-for="recipe in recipes"
      :key="recipe._id"
      :recipe="recipe"
      :primaryActionLabel="primaryActionLabel"
      @primaryActionSelected="bubblePrimaryAction"
    />
  </div>
</template>
<script>
import Vue from "vue";
import RecipeComponent from "@/components/Recipe";

export default Vue.extend({
  name: "RecipeList",
  props: ["recipes", "primaryActionLabel"],
  methods: {
    bubblePrimaryAction(payload) {
      this.$emit("primaryActionSelected", payload);
    },
  },
  components: {
    RecipeComponent,
  },
});
</script>
